import { Platform } from '@/types/config/config.types';

import { CONFIG_URL, configApi } from './config.api';

export const platformApi = configApi.injectEndpoints({
  endpoints: (builder) => ({
    createPlatform: builder.mutation<Platform, Partial<Platform>>({
      query: (platform) => ({
        url: `${CONFIG_URL}/platforms`,
        method: 'POST',
        body: platform,
      }),
    }),
    updatePlatform: builder.mutation<Platform, Platform>({
      query: (platform) => ({
        url: `${CONFIG_URL}/platforms/${platform.id}`,
        method: 'PUT',
        body: platform,
      }),
    }),
    deletePlatform: builder.mutation<void, number>({
      query: (id) => ({
        url: `${CONFIG_URL}/platforms/${id}`,
        method: 'DELETE',
      }),
    }),
    updatePlatformOffset: builder.mutation<void, { id: number; offset: number }>({
      query: ({ id, offset }) => ({
        url: `${CONFIG_URL}/platforms/${id}`,
        method: 'PATCH',
        params: {
          offset,
        },
      }),
    }),
  }),
});

export const {
  useUpdatePlatformOffsetMutation,
  useCreatePlatformMutation,
  useDeletePlatformMutation,
  useUpdatePlatformMutation,
} = platformApi;
